export const gtmProductViewEvent = (productData: any) => ({
  event: 'productView',
  ecommerce: {
    detail: {
      actionField: {
        action: 'detail',
        list: 'Category Page',
      },
      products: [productData],
    },
  },
});

export default gtmProductViewEvent;
